import router, { createRouter } from './index'

// 重置路由
function resetRouter () {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher
}

export default resetRouter
